import React from "react";

import { serverUrl } from "../../config";
import { useNavigate } from "react-router";
import { filesystem_root, subdomain } from "../../config";

import GridItem from "../../partials/gridItem";

export default function EventItem(props) {
  const navigate = useNavigate();
  const formatDate = (strDate) => {
    const empty = { weekday: "", date: { day: "", month: "" } };

    const toDate = (time) => {
      if (time == null || time === "") return null;
      const cleaned = String(time).replace(/\n/g, "").trim();

      if (/[-T:]/.test(cleaned)) {
        const [datePart, timePart] = cleaned.split("T");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hours, minutes] = timePart
          ? timePart.split(":").map(Number)
          : [0, 0];
        return new Date(year, month - 1, day, hours, minutes);
      }

      const date = new Date(parseInt(cleaned, 10) * 1000);
      return isNaN(date.getTime()) ? null : date;
    };

    const date = toDate(strDate);
    if (!date) return empty;

    const isISO = /[-T:]/.test(String(strDate).trim());
    const tzOption = isISO ? {} : { timeZone: "Europe/London" };

    const day = date.toLocaleString("en-GB", { day: "2-digit", ...tzOption });
    const month = date.toLocaleString("en-GB", { month: "short", ...tzOption });
    const weekday = date.toLocaleString("en-GB", {
      weekday: "short",
      ...tzOption,
    });

    return {
      weekday: weekday.toUpperCase(),
      date: {
        day,
        month: month.toUpperCase(),
      },
    };
  };

  let startDate = formatDate(props.item.field_start_date);
  let endDate = formatDate(props.item.field_end_date);

  if (props.creator) {
    return (
      <>
        <GridItem
          xs={12}
          sm={6}
          lg={3}
          xl={3}
          xxl={2}
          itemClass="events"
          item={props.item}
          bundle={props.item?.bundle}
          id={props.item?.id}
          title={props.item?.title}
          // field_body={
          //             props.item?.summary ?? ""
          // }
          category_label={props.item.category_labels}
          created={props.item?.created}
          hasImg={true}
          imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
          alt={`Poster for event ${props.item.id}`}
          cardActionArea={true}
          creator={props.creator}
          cardActionCallBack={
            props.creator
              ? () => {}
              : () => navigate(`/events/${props.item?.id}`)
          }
          contentType={props.contentType}
          shareEnabled
          route={"events"}
          field_access_token={props.item.access_token}
          sharePrompt={`This is a public link that enables you to share the event with your client, no login required.`}
        ></GridItem>
      </>
    );
  } else {
    const id = props.item?.id;
    // eslint-disable-next-line
    const imgSrc = `${filesystem_root}/${subdomain}/events/${id}/${id}/${props.item.field_featured_image}`;
    return (
      <GridItem
        xs={12}
        md={6}
        itemClass="event"
        bundle={props.item?.bundle}
        cardActionArea={true}
        cardActionCallBack={() =>
          navigate(`/events/${props.item?.id ?? props.item?.nid}`)
        }
        route="events"
        nid={props.item.nid}
        title={props.item.title}
        field_body={props.item?.summary ?? ""}
        category_label={props.item.category_labels}
        hasImg={true}
        imgSrc={`${serverUrl}${props.item.field_featured_image} `}
        event={true}
        textContainerCol={""}
        eventStartDate={startDate}
        eventEndDate={endDate}
        contentType={props.contentType}
        shareEnabled
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the event with your client, no login required.`}
      />
    );
  }
}
